// extracted by mini-css-extract-plugin
export default {"root":"h_tc43wjlV2mU9oeSjoE","placeHolderShimmer":"uNc8z1ilpkNmn01Hau0F"};